export default "__VITE_ASSET__3b22994d__"